import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'tachyons';
import MyApp from './Containers/MyApp';
// Destructor from robots -> {var1, var2, var3}
// import App from './Components/App';
// import Hello from './Components/Hello';
import reportWebVitals from './reportWebVitals';

// ReactDOM.render(
//   // <React.StrictMode>
//   //   <App />
//   // </React.StrictMode>,
//   <Hello greeting={'Hello React Ninja'} />,
//   document.getElementById('root')
// );

ReactDOM.render(
  <MyApp />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
